<template>
  <div class="home-view" @mousedown="cancelScroll" @touchstart="cancelScroll" >
    <DebugGrid :top="false" :bottom="false" :full="false"/>
    <HeroSection @scroll="scrollToPrizeSection" class="section" />
    <PrizesSection ref="prizeSection" class="section" />
    <InteractiveCanSection class="section" />
    <FinalCtaSection class="section"  />
  </div>
</template>

<script>
import HeroSection from './../containers/hero-section';
import PrizesSection from './../containers/prizes-section';
import InteractiveCanSection from './../containers/interactive-can-section';
import FinalCtaSection from './../containers/final-cta-section';
import DebugGrid from './../components/debug-grid';
import CheckRef from './../mixins/check-ref';
import SubmissionNavigation from './../mixins/submission-navigation';
import iframeChannel from './../core/iframe-channel';
import tracking from '../core/tracking';
// import { DURATION_SCROLL_HOME } from '../../design-tokens/build/dictionary';


export default {
  name: 'home',
  mixins: [CheckRef, SubmissionNavigation],
  components: {
    HeroSection,
    PrizesSection,
    InteractiveCanSection,
    FinalCtaSection,
    DebugGrid,
  },
  data() {
    return {
      scrolling: false, // if the scroll is jacked
    };
  },
  mounted() {
    tracking.trackEvent('p-rb-0');
    // this.initSubmissions();
  },
  beforeDestroy() {
    // cancel scroll updating
    this.cancelScroll();
  },
  beforeRouteUpdate(to, from, next) {
    if (to.query.submission !== '' && to.query.submission !== null && to.query.submission !== undefined) {
      this.getSubmission({
        submissionId: to.query.submission
      }).then(() => next());
      return;
    }
    next();
  },
  methods: {
    /**
     * If the user tries to interact while their scroll is jacked, give them back scroll
     */
    cancelScroll() {
      // if (this.scrolling) {
      //   scrollTo.stop();
      // }
    },

    /**
     * Set if we're scrolling or not
     */
    updateScrolling(scrolling) {
      this.scrolling = scrolling;
    },

    /**
     * Scroll to the prize section
     */
    scrollToPrizeSection() {
      if (!this.$refs.prizeSection || !this.$refs.prizeSection.$el) {
        return;
      }
      // this.updateScrolling(true);

      iframeChannel.scrollTo({
        target: this.$refs.prizeSection.$el,
        // duration: parseInt(DURATION_SCROLL_HOME, 10),
        // callback: this.updateScrolling.bind(this, false)
      });
    },
  }
};
</script>
<style lang="scss">
.home-view,
.terms-conditions-view {
  // Weird background handling because of android chrome
  position: relative;
  background-color: $color-background-page-ninja;
  background-size: auto;
  background-position: bottom center;
  background-repeat: repeat-x;
  background-image: url('./../assets/images/gradient-bkg.png');
  padding-bottom: 1px;

  @include global-media('small') {
    background-image: linear-gradient(to top, $color-base-ninja-light-blue-base, #182038 750px, #000000 900px);
  }

  @include global-media('medium') {
    background-image: linear-gradient(to top, $color-base-ninja-light-blue-base, #182038 700px, #000000 1400px);
  }
}
.home-view {
  &::before {
    position: absolute;
    content: '';
    // Weird background handling because of android chrome
    z-index: 0;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    pointer-events: none;

    background-size: 100%;
    background-position: bottom center;
    background-repeat: no-repeat;
    background-image: url('./../assets/images/ninja-logo-large.png');
    padding-bottom: 1px;

    @include global-media('small') {
      background-repeat: no-repeat;
      background-image: url('./../assets/images/ninja-logo-small.png');
    }
    @include global-media('medium') {
      background-repeat: no-repeat;
      background-image: url('./../assets/images/ninja-logo-large.png');
    }
  }
}
.app {
  transition: background-color $time-transition-fade-base;
}
.app.app--loaded {
  &.app--home,
  &.app--terms {
    background-color: $color-background-page-ninja;
  }
}
</style>
